export default function readablePayMethod(meth) {
  if (meth === 'installment') return 'განვადება'
  if (meth === 'cash') return 'გადახდა კურიერთან'
  if (meth === 'card') return 'ბარათით გადახდა'
  if (meth === 'bank') return 'საბანკო გადარიცხვა'
}
